import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: '50%',
    width: '100%',
    height: 'auto',
    paddingTop: '100%',
    border: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.common.white,
    position: 'relative',
  },
  wrapper: {
    margin: 'auto',
    textAlign: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    padding: theme.spacing(0.5),
  },
  children: {
    margin: 'auto',
    '& > *': {
      fontSize: theme.typography.pxToRem(14),
      fontWeight: 'bold',
      textAlign: 'center',
      display: 'block',
      color: theme.palette.text.primary,
      lineHeight: theme.typography.body1.lineHeight,
      [theme.breakpoints.up('sm')]: {
        fontSize: theme.typography.pxToRem(15),
      },
    },
  },
  responsiveSize: {
    '& > *': {
      [theme.breakpoints.only('xs')]: {
        fontSize: `min(3.5vw, ${theme.typography.pxToRem(14)})`,
      },
    },
  },
}));

const Circle = ({ children, classes: overridableClasses }) => {
  const classes = useStyles({ classes: overridableClasses });
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <div className={clsx(classes.children, classes.responsiveSize)}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Circle;
